<template>
	<az-container class="listagem ml-0 mb-5 d-flex flex-column">
		<v-row class="mt-2">
			<v-col>
				<h1 class="title font-weight-bold color-titulo">Anexos</h1>
			</v-col>
		</v-row>

		<div class="">
			<v-row>
				<v-col cols="12" sm="12" class="">
					<listagem-documentos-ata-view
						:itens="datasource"
						:total-paginas="totalPaginas"
						:total-itens="totalItens"
						:paginacao="paginacao"
						@paginar="setPaginacao"
						@resetar-page="resetarPaginaItemListagem()"
					></listagem-documentos-ata-view>
				</v-col>
			</v-row>
		</div>

		<botao-primario
			v-if="$store.state.isPodeAderir"
			id="aderir-ata"
			class="ma-3 align-self-end"
			nome-botao="Aderir Ata"
			cor-de-fundo="primary"
			@click="aderirAta()"
		></botao-primario>
	</az-container>
</template>
<script>
import mutationTypes from '@/core/constants/mutation-types'
import { actionTypes, routesNames } from '@/core/constants'
import ListagemDocumentosAtaView from '@/views/pages/ata/pesquisa/acessar/documentos/listagem/ListagemDocumentoAtaView.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'

export default {
	name: 'pesquisa-documentos-view',
	components: { BotaoPrimario, ListagemDocumentosAtaView },
	data() {
		return {
			paginacao: this.$store.state.ata.documento.paginacao,
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
		}
	},
	async mounted() {
		this.setIdAta()
		await this.carregarItens()
	},
	beforeDestroy() {
		this.resetarPaginaItemListagem()
		this.resetarPaginacao()
	},
	methods: {
		async carregarItens() {
			const retorno = await this.$store.dispatch(actionTypes.ATA.DOCUMENTO.BUSCAR_POR_FILTRO)

			this.datasource = retorno.itens
			this.totalItens = retorno.totalElements
			this.totalPaginas = retorno.totalPages
		},
		setIdAta() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTO.SET_ID_ATA, this.$route.params.id)
		},
		setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ATA.DOCUMENTO.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarItens()
		},
		resetarPaginaItemListagem() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTO.RESETAR_PAGINA_LISTAGEM)
		},
		resetarPaginacao() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTO.RESETAR_PAGINACAO_LISTAGEM)
		},
		aderirAta() {
			this.$router.push({
				name: routesNames.ADESAO.ADESAO_PUBLICA_VIEW,
				params: { id: this.$store.state.ata.documento.idAta },
			})
		},
	},
}
</script>
<style scoped lang="stylus"></style>
